import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { FacilityDtoSchema } from '../contracts';

const UpdateFacilityRequestDtoSchema = z.object({
  id: z.number(),
  coordinates: z
    .object({
      lat: z.number(),
      lng: z.number(),
    })
    .nullable(),
  managers: z.array(z.number()).nullable(),
  pricingModelId: z.number(),
  types: z
    .array(
      z.enum([
        'ASSISTED_LIVING',
        'MEMORY_CARE',
        'INDEPENDENT_LIVING',
        'SKILLED_NURSING',
      ])
    )
    .nullable(),
  yearBuilt: z.number().nonnegative().nullable(),
});

const UpdateFacilityResponseDtoSchema = FacilityDtoSchema.omit({
  bedsAvg: true,
  occupancy: true,
  staffAvg: true,
  status: true,
  name: true,
});

export type UpdateFacilityRequestDto = z.infer<
  typeof UpdateFacilityRequestDtoSchema
>;
export type UpdateFacilityResponseDto = z.infer<
  typeof UpdateFacilityResponseDtoSchema
>;

export const updateFacility = (
  dto: UpdateFacilityRequestDto,
  config?: AxiosRequestConfig<UpdateFacilityRequestDto>
) => {
  const { id, ...data } = UpdateFacilityRequestDtoSchema.parse(dto);
  return api
    .patch(`/facilities/${id}`, data, config)
    .then(responseContract(UpdateFacilityResponseDtoSchema));
};
